/**
 * スライドショー
 */
const CLASS_NAME = ".js-slideshow";

class SlideShow {
  constructor(elm) {
    this.elm = elm;
    this.$items = this.elm.querySelectorAll(".js-slideshow-list")[0];
    this.$navItems = elm.querySelectorAll(".js-slideshow-nav-item");
    this.slideLength = this.$navItems.length;
    this.animating = false;

    gsap.utils
      .toArray(this.$items.querySelectorAll(".js-slideshow-list-item"))
      .reverse()
      .forEach((elm, index) => {
        elm.classList.add(`-index-${index}`);
      });

    gsap.utils.toArray(this.$navItems).forEach((elm, index) => {
      elm.addEventListener("click", () => {
        if (this.animating) return;
        if (elm.classList.contains("-active")) return;

        this.animating = true;
        // -activeを削除
        gsap.utils.toArray(this.$navItems).forEach((elm2) => {
          elm2.classList.remove("-active");
        });
        // -activeを追加
        elm.classList.add("-active");
        this.changeSlide(index);
      });
    });
  }

  getTargetElm(index) {
    return gsap.utils
      .toArray(this.$items.querySelectorAll(".js-slideshow-list-item"))
      .find((elm) => {
        return elm.classList.contains(`-index-${index}`);
      });
  }

  changeSlide(index) {
    const $nextListItem = this.getTargetElm(index);
    this.$items.appendChild($nextListItem);
    gsap.from($nextListItem, {
      opacity: 0,
      onComplete: () => {
        this.animating = false;
      },
    });
  }
}

const init = () => {
  gsap.utils.toArray(CLASS_NAME).forEach((elm) => {
    new SlideShow(elm);
  });
};

export { init };
